import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { AddAssignmentQueueAccountSubmitParams } from '@/features/serviceModal/components/AddAssignmentQueueAccountModal/types';
import { EditAssignmentQueueAccountSubmitParams } from '@/features/serviceModal/components/EditAssignmentQueueAccountModal/types';
import { AssignmentQueuesSliceState, GetAssignmentQueuesResponse } from './types/AssignmentQueuesSliceState';

const initialState: AssignmentQueuesSliceState = {
  data: {
    listings: [],
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 50,
    },
  },
  statuses: {
    isLoading: false,
    isError: false,
  },
};

export const assignmentQueuesSlice = createSlice({
  name: 'assignmentQueuesSlice',
  initialState,
  reducers: {
    getAssignmentQueues: () => {},
    getAssignmentQueuesSuccess: (
      state,
      {
        payload: { shouldRewrite = true, data },
      }: PayloadAction<{ shouldRewrite?: boolean; data: GetAssignmentQueuesResponse }>,
    ) => {
      const listingsArray = Array.isArray(data.listings) ? data.listings : [data.listings];

      if (shouldRewrite) {
        state.data.listings = [...listingsArray];
        state.data.pagination = data.pagination;
      } else {
        state.data.listings = [...state.data.listings, ...listingsArray];
        state.data.pagination = data.pagination;
      }

      state.statuses.isLoading = false;
    },
    incrementAssignmentQueuesPage: (state) => {
      state.data.pagination.page++;
      state.statuses.isLoading = true;
    },
    setLoadingAssignmentQueuesData: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isLoading = payload;
    },
    getAssignmentQueuesDataError: (state) => {
      state.statuses.isLoading = false;
      state.statuses.isError = true;
    },
    resetAssignmentQueuesList(state) {
      state.data.pagination = initialState.data.pagination;
      state.data.listings = initialState.data.listings;
    },
    deleteAccountFromAssignmentQueue: (_, _action: PayloadAction<{ id: number | string }>) => {},
    addAssignmentQueueAccount: (_, _action: PayloadAction<AddAssignmentQueueAccountSubmitParams>) => {},
    updateAssignmentQueueAccount: (_, _action: PayloadAction<EditAssignmentQueueAccountSubmitParams>) => {},
  },
});

export const {
  setLoadingAssignmentQueuesData,
  getAssignmentQueues,
  getAssignmentQueuesSuccess,
  incrementAssignmentQueuesPage,
  getAssignmentQueuesDataError,
  deleteAccountFromAssignmentQueue,
  addAssignmentQueueAccount,
  updateAssignmentQueueAccount,
} = assignmentQueuesSlice.actions;

export const assignmentQueuesReducer = assignmentQueuesSlice.reducer;
export const assignmentQueuesReducerPath = assignmentQueuesSlice.reducerPath;
